var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner',{staticClass:"mb-0"}),_c('Login',{staticClass:"mt-1",attrs:{"isDialogOpen":_vm.showLoginDialog,"title":"Mobile Login","defaultOfficeCode":_vm.defaultOfficeCode},on:{"loggedIn":_vm.loggedInEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }